import { createFileRoute } from "@tanstack/react-router";

import { PraxaWorkflowDetail } from "../components/praxa/PraxaWorkflowSurface";

export const Route = createFileRoute("/w/$workspaceId/workflows/$workflowId")({
  component: PraxaWorkflowDetailRoute,
});

function PraxaWorkflowDetailRoute() {
  const { workflowId, workspaceId } = Route.useParams();
  return <PraxaWorkflowDetail workflowId={workflowId} workspaceId={workspaceId} />;
}
